import { Select } from "antd"
import { SizeType } from "antd/es/config-provider/SizeContext";

interface Props  {
    onChange: (value : string) => void,
    size? : SizeType,
    defaultValue? : string,
    style? : any
    onClear : () => void,
}

const SelectAccredited = (props: Props) => {
    return (
        <div style={{width : '100%'}}>
            <Select
                {...props}
                size={props.size}
                labelInValue
                allowClear
                onClear={() => {
                    if(props.onClear){
                        props?.onClear();
                    }
                }}
                defaultValue={props?.defaultValue || ''}
                style={props.style}
                onChange={(value:any) => {
                    if(value){
                        props.onChange(value);
                    }
                }}
                options={[
                    { label : "Si", value : 1},
                    { label : "No", value : 0}
                ]}
            />        
        </div>
    );
}

export default SelectAccredited